import { formatDateFunc } from '@/pages/opinion/utils/time';
import { sentimentNumber } from '../../render-helper';
import { indicatorsMap } from '@/pages/opinion/pages/Summary/constants';

export default function summaryTopicTrendsColumns(params: {
  tableHeader: any;
  renderText: any;
  indicators: any;
  date_type: any;
}) {
  let { tableHeader, renderText, indicators, date_type } = params;

  const isRatio = ['mentions_ratio', 'negative_mentions'].includes(indicators);

  function renderTotal(item: { [x: string]: any }, key: string | number) {
    if (indicators === 'sentiment') {
      return sentimentNumber(item, key);
    }
    let total = item[key];
    return total;
  }

  function renderTime(item: { [x: string]: any }, key: string | number) {
    let time = item[key];
    return formatDateFunc(date_type)(time);
  }

  function renderOther(item: { [x: string]: any }, key: string | number) {
    let value = item[key];
    return value;
  }

  let headerText = indicatorsMap[indicators];
  if (indicators === 'mentions_ratio') {
    headerText = 'Mentions';
  } else if (indicators === 'negative_mentions') {
    headerText = 'Negative Mentions';
  }

  const tableColumns: any = [
    {
      render: 'time',
      header: 'Time',
      fixed: 'left',
      renderHelper: [renderTime],
    },
    {
      render: 'total',
      align: 'right',
      header: headerText,
      renderHelper: [renderTotal],
    },
  ];

  // if (isRatio) {
  //   tableColumns[1].numFmt = '0.00%';
  // }

  tableHeader.forEach((title: any, index: string | number) => {
    let realTitle = renderText[index];
    let column: any = {
      render: title,
      align: 'right',
      header: realTitle,
      renderHelper: [renderOther],
    };
    if (isRatio) {
      column['numFmt'] = '0.00%';
    }
    if (indicators === 'sentiment') {
      column.renderHelper = [sentimentNumber];
    }
    tableColumns.push(column);
  });

  return tableColumns;
}
